import MainContainer from "layout/MainContainer";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { useNavigate } from "react-router-dom";
import PieChart from "components/PieChart";
import BarChart from "components/BarGraph";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Investment = () => {
  const navigate = useNavigate();

  const pieData = {
    labels: ["Gold", "Silver", "Bronze"],
    datasets: [
      {
        label: "Votes",
        data: [300, 50, 100],
        backgroundColor: ["#FFD700", "#C0C0C0", "#CD7F32"],
        borderWidth: 1,
      },
    ],
  };

  const barData = {
    labels: ["Usa", "Uk", "Canada", "Australia"],
    datasets: [
      {
        label: "Investments",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: "rgba(0, 96, 57, 0.6)",
      },
    ],
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Investment Reporting Dashboard</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Investment Reporting Dashboard
        </p>
      </div>

      <div className="stats_boxes gap_m" style={{ marginBottom: "30px" }}>
        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>$ 178,000</h2>
          <p>Active Investments</p>
        </div>

        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>9000</h2>
          <p>Active Investors</p>
        </div>

        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>$ 175,000</h2>
          <p>ROI Disbursed This Month</p>
        </div>

        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>90</h2>
          <p>Pending Approvals</p>
        </div>
      </div>

      <div className="grid_sc gap_m ">
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Plan-wise Investment Distribution</h2>
          <div
            style={{
              width: 350,
              height: 350,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <PieChart data={pieData} />
          </div>
        </Item>

        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Country-wise Investment Statistics</h2>

          <BarChart data={barData} />
        </Item>
      </div>
    </MainContainer>
  );
};

export default Investment;
